// extracted by mini-css-extract-plugin
export default {"helpFAQContainer":"style_helpFAQContainer__roeln","accordionContainer":"style_accordionContainer__M6nRY"};